import { localize } from "locale"
import * as R from "ramda"

export const roles = {
  approver: { value: "Approver", name: localize("approver") },
  editor: { value: "Editor", name: localize("editor") },
}

export const assessmentRoles = R.values(roles)
